import React, { useState } from "react";
import AbutmentPrepWidget from "../../manager/widgets/AbutmentPrepWidget";
import CrownProcessWidget from "../../manager/widgets/CrownProcessWidget";
import FpdCasesWidget from "./FpdCasesWidget";
import CrownBridgeEstimate from "./CrownBridgeEstimate";
import ProcedureHistory from "../shared/ProcedureHistory";
import "../Treatments.css";

export default function ProsthoManager() {
    const [tab, setTab] = useState<"queue" | "estimate" | "history">("queue");

    return (
        <div className="mod-standalone-window" style={{ display: 'flex', flexDirection: 'column', gap: '20px', minHeight: 'calc(100dvh - 100px)' }}>
            <div className="mod-window-header" style={{ paddingBottom: 0, borderBottom: 'none', marginBottom: 0 }}>
                <div>
                    <h2 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>🦷 Prosthodontics Manager</h2>
                    <p className="mod-text-muted">Manage FPD cases, active queue, and cost estimates.</p>
                </div>
            </div>

            <div className="mod-sub-nav">
                <button className={`mod-sub-btn ${tab === 'queue' ? 'active' : ''}`} onClick={() => setTab('queue')}>Active Queue</button>
                <button className={`mod-sub-btn ${tab === 'estimate' ? 'active' : ''}`} onClick={() => setTab('estimate')}>Crown & Bridge Estimate</button>
                <button className={`mod-sub-btn ${tab === 'history' ? 'active' : ''}`} onClick={() => setTab('history')}>Clinical History</button>
            </div>

            <div className="mod-panel-fade-in" style={{ flex: 1 }}>
                {tab === "queue" ? (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '20px' }}>
                        <AbutmentPrepWidget />
                        <FpdCasesWidget />
                        <CrownProcessWidget />
                    </div>
                ) : tab === "estimate" ? (
                    <CrownBridgeEstimate />
                ) : (
                    <ProcedureHistory procedureType="Prostho" title="Prosthodontic History" />
                )}
            </div>
        </div>
    );
}
